import React, { useEffect, useRef, type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  LINK_VARIANT_HIGHLIGHT,
  Link,
  TooltipUtils,
} from 'mailup-web-components'

import { evalCondition } from 'mailup-react-helpers'

import {
  canBuyEngagementFilters,
  getEngagementDocumentationURL,
  openMshopEngagementFilters,
} from 'Helpers/ecommerce'

import { modalDelStatsContactOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/modalDelStatsContact'
import { recipientsEngagementState } from 'Pages/RecipientsList/recoil/state/engagemet'

const StyledUL = styled.ul`
  margin-top: 16px;
  margin-bottom: 16px;
  li {
    display: list-item;
    list-style-type: disc;
    margin-left: 1em;
  }
`

const EngagementTooltip: FC = () => {
  const intl = useIntl()

  const hasDelStats: boolean = evalCondition('co:DELSTATS')

  const { items } = useRecoilValue(recipientsEngagementState)

  const modalDelStatsContactOpen = useRecoilCallback(
    modalDelStatsContactOpenCallback,
    [],
  )

  const tooltipRef = useRef<{ tooltipRef: any }>(null)

  const canBuy = canBuyEngagementFilters()

  useEffect(() => {
    setTimeout(TooltipUtils.rebuild as () => void, 500)
  }, [items])

  //  event='click'      clickable

  const handleClickBuy = (): void => {
    if (canBuy) {
      openMshopEngagementFilters()
    } else {
      void modalDelStatsContactOpen({
        requestTitle: 'Piattaforma #ID# - Filtri di Engagement',
        requestDescription: `Email: #EMAIL#
        L'utente ha dimostrato interesse al prodotto lasciando il proprio contatto nella pagina: Recipients List
        Codice prodotto di riferimento: MUFIENG01`,
      })
    }
  }

  return hasDelStats ? (
    <TooltipUtils
      ref={tooltipRef}
      id="engagement-tooltip"
      type="light"
      effect="solid"
      className="c-tooltip"
    >
      {intl.formatMessage(
        {
          id: 'Load.RecipientsList.RecipientsEngagementTooltip',
        },
        {
          linebreak: (
            <>
              <br />
              <br />
            </>
          ),
          ul: (ulchunk) => <StyledUL>{ulchunk}</StyledUL>,
          li: (lichunk) => <li>{lichunk}</li>,
        },
      )}
    </TooltipUtils>
  ) : (
    <TooltipUtils
      ref={tooltipRef}
      id="engagement-tooltip"
      type="light"
      effect="solid"
      className="c-tooltip"
      event="click"
      globalEventOff="click"
      clickable
    >
      {intl.formatMessage(
        {
          id: 'Load.RecipientsList.RecipientsEngagementUpsellingTooltip',
        },
        {
          linebreak: <br />,
          more: (chunks) => (
            <Link
              variant={LINK_VARIANT_HIGHLIGHT}
              data-mu-test="engagement-upselling-tooltip__more"
              href={getEngagementDocumentationURL(intl.locale)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {chunks}
            </Link>
          ),
          buy: (chunks) => (
            <Link
              variant={LINK_VARIANT_HIGHLIGHT}
              data-mu-test="engagement-upselling-tooltip__buy"
              onClick={handleClickBuy}
            >
              {chunks}
            </Link>
          ),
        },
      )}
    </TooltipUtils>
  )
}

export default EngagementTooltip
